module.exports = __webpack_public_path__ + "assets/img/26_1590_big.18d8fe72.jpg";